import { createSection } from '@formkit/inputs'

/**
 * Inner section of a multi-step step.
 *
 * @public
 */
export const stepInner = createSection('stepInner', 'div')
